export default "__VITE_ASSET__RVlxg4uH__"